module.exports = __webpack_public_path__ + "0f42c5e3a59f40f8d6bf281e6e9c571e.svg";